import React from 'react';
import { NavLink } from 'react-router-dom';

export default function NavLst(props) {

    const [expandSM, setSM] = React.useState(false);

    var expandClass = (expandSM ? " expand" : "");


        return (
            <header>
                <div className="sidebar-small">
                    <button className={["sidebar-sm-btn" + expandClass]} onClick={()=> {setSM(!expandSM)}}>
                        <span className="material-icons">
                            menu
                        </span>
                    </button>
                </div>
                <div>
                <ul className={["nav nav-lst-sm" + expandClass]}>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-link-sm active" onClick={() => {setSM(false)}} to="/schedule">Home</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-link-sm" onClick={() => {setSM(false)}} to="/search">Search</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-link-sm" onClick={() => {setSM(false)}} to="/about">About</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-link-sm" onClick={() => {setSM(false)}} to="/login">Login</NavLink>
                        </li>
                    </ul>
                </div>

                <div className="sidebar sidebar-background">
                    <nav className="nav nav-bar">
                        <li className="nav-item h-center">
                            <NavLink className="nav-link" to="/schedule">Home</NavLink>
                        </li>
                        <li className="nav-item h-center">
                            <NavLink className="nav-link" to="/search">Search</NavLink>
                        </li>
                        <li className="nav-item h-center">
                            <NavLink className="nav-link" to="/about">About</NavLink>
                        </li>
                    </nav>

                    <div className="login">
                            <NavLink className="nav-link" to="/login">Login</NavLink>
                    </div>
                </div>
            </header>
        );
}